import { TravelMap } from '../components/TravelMap';
import { BlogList } from '@/components/BlogList';
import { travelLocations } from '../components/TravelMap';

// Function to count unique countries
function getUniqueCountriesCount(locations: { name: string }[]): number {
  const countrySet = new Set(
    locations.map(location => {
      const parts = location.name.split(', ');
      return parts[parts.length - 1];
    })
  );
  return countrySet.size;
}

export function Traveling() {
  const countriesCount = getUniqueCountriesCount(travelLocations);

  return (
    <div className="min-h-screen">
      <div className="relative h-[56vh] md:h-[70vh]">
        <TravelMap />
      </div>
      <div className="container mx-auto px-4 py-8 bg-background/95 backdrop-blur-sm">
        <div className="mb-6">
          {/* Desktop: Title left, boxes right */}
          <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-6">
            <div className="md:flex-1">
              <h1 className="text-4xl font-bold mb-2">☝🏻 My Travel Map</h1>
              <p className="text-lg text-muted-foreground">
                Follow my journey around the world
              </p>
            </div>
            
            {/* Stats boxes - Mobile: stacked under subtitle, Desktop: side by side on the right */}
            <div className="flex flex-col sm:flex-row gap-4 md:flex-row">
              {/* Goal box */}
              <div className="border rounded-lg py-2 px-4 bg-white/50 dark:bg-gray-800/50 shadow-sm">
                <div className="flex items-center justify-between sm:justify-center md:justify-center">
                  <span className="text-4xl sm:hidden md:inline">🎯</span>
                  <div className="flex flex-col items-end">
                    <div className="text-2xl font-bold text-orange-600">150</div>
                    <div className="text-sm text-muted-foreground">Countries Goal</div>
                  </div>
                </div>
              </div>
              
              {/* Countries visited box */}
              <div className="border rounded-lg py-2 px-4 bg-white/50 dark:bg-gray-800/50 shadow-sm">
                <div className="flex items-center justify-between sm:justify-center md:justify-center">
                  <span className="text-4xl sm:hidden md:inline">🌎</span>
                  <div className="flex flex-col items-end">
                    <div className="text-2xl font-bold text-blue-600">{countriesCount}</div>
                    <div className="text-sm text-muted-foreground">Countries Visited</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12">
          <BlogList selectedCategory="traveling" />
        </div>
      </div>
    </div>
  );
} 